// extracted by mini-css-extract-plugin
module.exports = {"wrap":"terms-and-condition_wrap__1GsXq","textWrap":"terms-and-condition_textWrap__fKKGC","fineprint":"terms-and-condition_fineprint__1rFSg"};